import React from "react";
import { Provider } from "react-redux";

import createStore from "./src/store/index";
import { AuthProvider } from "./src/contexts/AuthContext";
import { useApiAuth } from "./src/hooks/useApiAuth";

// Component to initialize API auth handling
const ApiAuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useApiAuth();
  return <>{children}</>;
};

export default ({ element }: { element: React.ReactNode }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  const store = createStore();

  return (
    <Provider store={store}>
      <AuthProvider>
        <ApiAuthInitializer>{element}</ApiAuthInitializer>
      </AuthProvider>
    </Provider>
  );
};
